import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

import { Pagination } from './pagination.types'
import { Error } from './error.types'

interface DiagnosticHypothesisData  {
  id: number
  code: string
  description: string
}

interface ListAllDiagnosticHypothesesData {
  cids: DiagnosticHypothesisData[]
  pagination: Pagination
}

interface DiagnosticHypothesis {
  id: number
  cidCode: string
  description: string
}

interface ListAllDiagnosticHypothesesResponse {
  diagnosticHypotheses: DiagnosticHypothesis[]
  pagination: Pagination
}

export const listAllDiagnosticHypotheses = (query?: string, page?: number): Promise<ListAllDiagnosticHypothesesResponse> => {
  const endpoint = apiEndpoints.CIDS

  const params = {
    per_page: 10,
    ...(query && { query }),
    ...(page && { page }),
  }

  return new Promise<ListAllDiagnosticHypothesesResponse> ((resolve, reject) => {
    axios.get<ListAllDiagnosticHypothesesData>(endpoint, { params })
      .then(response => {
        const diagnosticHypotheses = response.data.cids.map(hypothesis => {
          return {
            id: hypothesis.id,
            description: hypothesis.description,
            cidCode: hypothesis.code,
          } as DiagnosticHypothesis
        })

        const pagination = response.data.pagination

        resolve({
          diagnosticHypotheses,
          pagination,
        })
      })
      .catch((error: Error) =>
        reject(error?.response?.status)
      )
  })
}
